import { createSelector } from "@reduxjs/toolkit";
import { ReferentialKey } from "api/referential";
import { RootState } from "app/store";

const selectReferentialState = (state: RootState) => state.referential;

export const selectReferentialsData = createSelector(
  [selectReferentialState],
  (referentialState) => referentialState.referentialsData
);

// Fonction utilitaire pour récupérer l'ID d'un référentiel par son code
export const selectReferentialIdByCode = createSelector(
  [
    selectReferentialsData,
    (state: RootState, referentialKey: ReferentialKey, code: string | undefined) => ({ referentialKey, code })
  ],
  (referentialsData, { referentialKey, code }) => {
    if (!code) return null;
    const referentials = referentialsData[referentialKey];
    const foundReferential = referentials.find(ref => ref.code === code);
    return foundReferential?.id || null;
  }
);

export const selectReferentialLabelsByIds = createSelector(
  [
    selectReferentialsData,
    (state, referentialKey: ReferentialKey, ids: string[]) => ({ referentialKey, ids })
  ],
  (referentialsData, { referentialKey, ids }) => {
    const referentials = referentialsData[referentialKey];
    return ids.map(id => {
      const found = referentials.find(ref => ref.id === id);
      return found?.label || null;
    });
  }
);
